export const PHONE_NUMBER_REGEX = /^[0-9]{10}$/;

export const stripCountryCode = (phone: string): string => {
  if (phone.startsWith("+91")) return phone.slice(3);
  if (phone.startsWith("91")) return phone.slice(2);
  return phone;
};

export const addCountryCode = (phone: string): string => {
  if (phone.startsWith("+91")) return phone;
  if (phone.startsWith("91")) return `+${phone}`;
  return `+91${phone}`;
};
